import type { Breakpoint } from "@mui/material";
import { Container } from "@mui/material";
import type { ReactNode } from "react";

export function Page({
  children,
  maxWidth = "xl",
}: {
  children: ReactNode;
  maxWidth?: Breakpoint | false;
}) {
  return (
    <Container
      component="main"
      maxWidth={maxWidth}
      sx={{
        paddingY: 2,
        bgcolor: "background.default",
        height: "100%",
        marginBottom: 20,
      }}
    >
      {children}
    </Container>
  );
}
